import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SetCallForwardingRuleModal from './set-call-forwarding-rule-modal';
import { IProps } from './types';
import { bulkUpdatePhoneNumberSettingsRequest, updatePhoneNumberSettingsRequest } from '../../../../../../extra-actions';
import { RootState } from '../../../../../../../../store/root-reducer';
import { PhoneNumberSettingCode } from '../../../../../../types/phone-numbers';

const SetCallForwardingRuleModalContainer: React.FC<IProps> = ({
  show,
  onClose,
  selectedPhoneNumbers,
  deSelectedPhoneNumbers,
  isSelectAllAcrossPages,
  phoneNumberFilters,
  searchText,
  refreshPhoneNumbers,
  handleClearSelection,
  convertFiltersToAPIFormat,
}) => {
  const dispatch = useDispatch<any>();
  const bulkUpdatePhoneNumberSettingsRequestState = useSelector((state: RootState) => state.dialer.bulkUpdatePhoneNumberSettingsRequest);
  const updatePhoneNumberSettingsRequestState = useSelector((state: RootState) => state.dialer.updatePhoneNumberSettingsRequest[PhoneNumberSettingCode.FORWARDING_ENABLED]);

  const handleSubmit = useCallback(async (settings: Array<{ code: string; value: string | null }>) => {
    const selectedCount = selectedPhoneNumbers?.length || 0;
    const deSelectedCount = deSelectedPhoneNumbers?.length || 0;

    try {
      if (selectedCount > 0 && deSelectedCount === 0 && selectedPhoneNumbers) {
        const phoneNumberIds = selectedPhoneNumbers.map((item) => item.id);
        await dispatch(updatePhoneNumberSettingsRequest({
          phoneNumberIds,
          settings,
        })).unwrap();
      } else if (selectedCount === 0 && deSelectedCount >= 0 && deSelectedPhoneNumbers && isSelectAllAcrossPages) {
        const deselectedPhoneNumberIds = deSelectedPhoneNumbers.map((item) => item.id);
        const apiFilters = convertFiltersToAPIFormat?.(phoneNumberFilters, searchText);
        await dispatch(bulkUpdatePhoneNumberSettingsRequest({
          ...(deselectedPhoneNumberIds.length > 0 && { deselectedPhoneNumberIds }),
          ...(apiFilters && { phoneNumberFilters: apiFilters }),
          settings,
        })).unwrap();
      }

      handleClearSelection?.();
      onClose?.();
    } catch (e) {
      // swallow error; UI can be improved with toast if needed
    }
  }, [convertFiltersToAPIFormat, deSelectedPhoneNumbers, dispatch, handleClearSelection, isSelectAllAcrossPages, onClose, phoneNumberFilters, refreshPhoneNumbers, searchText, selectedPhoneNumbers]);



  return (
    <SetCallForwardingRuleModal
      show={show}
      onClose={onClose}
      onSubmit={handleSubmit}
      bulkUpdateForwardingRuleStatus={bulkUpdatePhoneNumberSettingsRequestState?.status}
      updateForwardingRuleStatus={updatePhoneNumberSettingsRequestState?.status}
    />
  );
};

export default memo(SetCallForwardingRuleModalContainer);

